import { render, staticRenderFns } from "./formPassword.vue?vue&type=template&id=03bde846&scoped=true&"
import script from "./formPassword.vue?vue&type=script&lang=js&"
export * from "./formPassword.vue?vue&type=script&lang=js&"
import style0 from "./formPassword.vue?vue&type=style&index=0&id=03bde846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bde846",
  null
  
)

export default component.exports